import DropdownSelect, {
  DropdownOption,
} from "@components/common/dropdown/DropdownSelect";
import { useAuth } from "@hooks";
import { FormControl } from "@mui/material";
import { useEffect } from "react";

export default function TeamUserDropdown({
  propHandleChange,
  currentUser,
  setCurrentUser,
  currentTeam,
}) {
  const { userUuid } = useAuth();

  useEffect(() => {
    setCurrentUser(userUuid);
  }, [currentTeam]);

  return (
    <>
      <FormControl
        sx={{ position: "relative", mt: 1 }}
        size="small"
        className="w-full"
      >
        <div className="flex flex-1 flex-row items-center dark:bg-gray-700 bg-gray-100 pl-3 rounded-xl text-indigo-500 relative">
          <DropdownSelect
            labelId="team-label"
            value={currentUser}
            onChange={propHandleChange}
            width="w-full min-w-48"
          >
            {currentTeam?.users?.map((user) => (
              <DropdownOption key={user.uuid} value={user.uuid}>
                <h4 className="text-sm ml-2 font-medium truncate">
                  {user.firstName} {user.lastName}
                  {userUuid === user.uuid && (
                    <span className="text-xs font-normal">
                      {" "}
                      (You)
                    </span>
                  )}
                </h4>
              </DropdownOption>
            ))}
          </DropdownSelect>
        </div>
      </FormControl>
    </>
  );
}
